import { decode } from 'js-base64';
import { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';

import { getScope, localStorageSetTtlItem } from '../utils/authenticate';

export const AuthCallback: FunctionComponent = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const state = urlParams.get('state') || '';
	const token = urlParams.get('access_token') || '';
	let scope = urlParams.get('scope') || '';
	const ttl = parseInt(urlParams.get('expires_in') || '180000', 10);

	const expectedState = localStorage.getItem('auth.expectedState');

	const retrievedState = decode(state);

	let searchString = '';
	try {
		searchString = JSON.parse(retrievedState).search;
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Problem parsing state');
		const scopeParts = scope.split('.');
		if (scopeParts.length > 2) {
			searchString = `?customer=${scopeParts[1]}&environment=${scopeParts[2]}`; // hopefully won't ever hit this
		}
	}

	if (!scope) {
		const searchParams = new URLSearchParams(searchString.replace('?', ''));
		scope = getScope(searchParams.get('customer') || '', searchParams.get('service') || '');
	}

	if (!state || !token || !scope) {
		// eslint-disable-next-line no-console
		console.log("Didn't get back an expected property");

		return null;
	}

	localStorageSetTtlItem(
		`${scope}.token`,
		state === expectedState ? token : 'STATE_MISMATCH',
		ttl,
	);

	return <Navigate to={`/${searchString}`} replace />;
};
